// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__YG4Z1","preferencesContainer":"Profile_preferencesContainer__nKl+y"};